import UIStrings from '@/Utils/UIStrings';

interface DialogCardInterviewHeaderProps {
    name: string;
}

function DialogCardInterviewHeader({ name }: DialogCardInterviewHeaderProps) {
    return (
        <div className="text-foreground text-xl font-bold">
            {`${UIStrings.Invite} ${name} ${UIStrings.ForAnInterview}`}
        </div>
    );
}

export default DialogCardInterviewHeader;
